import {Injectable} from '@angular/core';
import {Resolve, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs/Observable';

import {OrganizationService} from '../organization.service';


@Injectable()
export class AllOrganizationsResolver implements Resolve<any> {
	constructor(
		private organizationService: OrganizationService
	) {}


	params: any = {};


	resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
		// console.log('AllFilmsResolver called    #1');
		// let startResolve = Date.now();

		this.params = JSON.parse(JSON.stringify(route.params));

		let thePromise = new Promise((resolve, reject) => {
			// this.reviewerFilmService.getFilms()
			this.organizationService.getOrganizations()
				.then((organizations: any) => {

					// let endResolve = Date.now();
					// console.log('AllFilmsResolver called    #2, took ' + (endResolve - startResolve) + ' msec' );


					let allOrganizationsInfo = {
						allOrganizations: organizations.allOrganizations.organizations,
						params: this.params
					};
					resolve(allOrganizationsInfo);
				})
				.catch((err) => {
					return reject(err);
				});
		});

		return Observable.fromPromise(thePromise);
	}
}



// WEBPACK FOOTER //
// /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/services/resolvers/all-organizations.resolver.ts